import {
  isHeidi1BillingEligibleForHeidi2,
  type Heidi2OptInBillingInfo,
  type Heidi2OptInGate,
} from './heidi-2-opt-in-eligibility';

export type Heidi2RequestAccessGate = {
  isHeidi2OptInEnabled: boolean;
  /** False during workspace-switch reload. */
  isWorkspaceIdSettled: boolean;
  /** Includes paused + Chronicle. */
  isClinicalRecordingActive: boolean;
  /** `user.is_managed`; unknown while loading. */
  isUserManaged: boolean | null | undefined;
  /**
   * False while `useCurrentWorkspace()` is still null. A loading workspace is
   * not "not an admin" — treating it as one flashes this strip for admins.
   */
  isWorkspaceResolved: boolean;
  /** `JoinedWorkspaceRelation.user_role === 'ADMIN'`. */
  isWorkspaceAdmin: boolean;
  /**
   * `ModalId.CLINICIAN_TRIAL` is showing or is the unfiltered queue head.
   * Unqueued T4 chrome would otherwise stack on that T3 trial modal.
   */
  isClinicianTrialModalBlocking: boolean;
  /**
   * Launch queue has evaluated with user data, seen-modal ids and a billing
   * response from this page load. Reading the queue before then sees an empty
   * list and this surface flashes first.
   */
  isClinicianTrialEligibilityLoaded: boolean;
  /** Same commerce verdict the admin opt-in strip uses. A Max seat is already on Heidi 2. */
  isMaxBillingSeat: Heidi2OptInGate['isMaxBillingSeat'];
};

/**
 * Heidi 1 non-admin cohort for the request-access strip.
 * Inline chrome applies T4 R1/R2 itself; R4 is `MODAL_CLOSED_RULES`.
 */
export function computeShouldShowHeidi2RequestAccess(
  gate: Heidi2RequestAccessGate,
  billingInfo: Heidi2OptInBillingInfo | null | undefined
): boolean {
  if (!gate.isClinicianTrialEligibilityLoaded) {
    return false;
  }
  if (!gate.isWorkspaceIdSettled) {
    return false;
  }
  if (!gate.isHeidi2OptInEnabled) {
    return false;
  }
  if (gate.isClinicalRecordingActive) {
    return false;
  }
  if (gate.isClinicianTrialModalBlocking) {
    return false;
  }
  // Unknown (`undefined`/`null`) counts as managed — no flash on enterprise.
  if (gate.isUserManaged !== false) {
    return false;
  }
  if (!gate.isWorkspaceResolved) {
    return false;
  }
  if (gate.isWorkspaceAdmin) {
    return false;
  }
  return isHeidi1BillingEligibleForHeidi2(billingInfo, gate.isMaxBillingSeat);
}
